"use client";
import * as React from "react";
const SvgSentimentVerySatisfiedOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 0a8 8 0 0 0-8 8 8 8 0 1 0 16 0 8 8 0 0 0-8-8m0 14.4A6.4 6.4 0 0 1 1.6 8 6.4 6.4 0 1 1 8 14.4m.8-8.05.85.85.85-.85.84.85.85-.85-1.7-1.7zm-3.3 0 .85.85.85-.85-1.7-1.7-1.7 1.7.86.85zM8 12.4a4.4 4.4 0 0 0 4.09-2.8H3.9A4.4 4.4 0 0 0 8 12.4" }));
export {
  SvgSentimentVerySatisfiedOutlined as default
};
